import React, { PureComponent } from 'react';
import { Redirect, Route, Router, Switch } from 'react-router-dom';

import ForgotPassword from './auth/forgot-password';
import Layout from './layout';
import Login from './auth/login';
import NotFound from './not-found';
import Printable from './printable';
import Register from './auth/register';
import ResetPassword from './auth/reset-password';
import history from '../store/history';

export default class AppRouter extends PureComponent {
  render() {
    return (
      <Router history={history}>
        <Switch>
          <Route component={ForgotPassword} exact path="/forgot-password" />
          <Route component={Login} exact path="/login" />
          <Route component={Printable} exact path="/printable" />
          <Route component={Register} exact path="/register" />
          <Route component={ResetPassword} exact path="/reset-password" />
          <Route component={Layout} path="/a" />
          <Redirect exact from="/" to="/login" />
          <Route component={NotFound} />
        </Switch>
      </Router>
    );
  }
}
